import { LocaleCode } from '@/i18n/locales';
import { getOrCreateStoreToken } from '@/shared/utils/store-token';
import { getOrCreateVisitorId } from '@/shared/utils/visitor-id';
import { fetchWebContextId } from '@/features/games-app/shared/helpers/get-web-context-id';

const buildDownloadLink = (
  webContextId: string | undefined,
  brand = 'wildgames',
  DP = 'wildgames',
) => {
  let link = `https://download.wildgames.com/gamesapp/TouchpointInstallers/${brand}/Setup-${DP}`;

  if (webContextId) {
    link = `${link}!${webContextId}`;
  }

  return `${link}.exe`;
};

export const fetchDownLoadUrl = async ({
  language,
  activeCurrency,
  email,
  countryCode,
}: {
  language: LocaleCode;
  activeCurrency: string;
  email?: string;
  countryCode: string;
}) => {
  const brand = process.env.NEXT_PUBLIC_DEFAULT_DP;
  const DP = process.env.NEXT_PUBLIC_DEFAULT_DP;
  const visitorId = await getOrCreateVisitorId();
  const storeToken = await getOrCreateStoreToken();

  // TODO: consider review of this payload (WTDEV-526)
  // swizzler is required in webcontext request.
  const payload = {
    activeCurrency,
    language,
    email,
    countryCode,
    visitorId,
    storeToken,
    DP,
    swizzler: visitorId,
  };

  let webContextId;

  try {
    const webContextIdResp = await fetchWebContextId(payload);
    if (webContextIdResp.error || !webContextIdResp.webContextId) {
      throw new Error('Failed to get web context ID');
    }
    webContextId = webContextIdResp.webContextId;
  } catch (error) {
    console.error('error', error);
    return { error: 'Failed to get web context ID' };
  }

  return buildDownloadLink(webContextId, brand, DP);
};
